import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import { toast } from "react-toastify"
import axios from "axios"
import { movieOrderDefaultURL } from '../../../components/CommonApis/CommonMovieOrderApi';
import { adminApiHeader } from '../../../components/CommonApis/CommonApiUrl';
import Response_Processing from '../../../layout/Others/Response_Processing';
import AdminSaveHeader from '../../../components/CommonComponents/AdminSaveHeader';
import Wrapper from '../../../components/CommonComponents/Wrapper';
import MessageLabel from '../../../components/CommonComponents/MessageLabel';
import AdminCustomInput from '../../../components/CommonComponents/AdminCustomInput';
import AdminBackNavigation from '../../../components/CommonComponents/AdminBackNavigation';
import FormContainer from '../../../components/CommonComponents/FormContainer';
import LeftWrapper from '../../../components/CommonComponents/LeftWrapper';
import RightWrapper from '../../../components/CommonComponents/RightWrapper';
import AdminCustomSelect from '../../../components/CommonComponents/AdminCustomSelect';
import MessageHeading from '../../../components/CommonComponents/MessageHeading';

const MovieOrderEdit = () => {
    const { id } = useParams();
    const [withOutRefresh, setWithOutRefresh] = useState(false)
    const [apiData, setApiData] = useState([]);
    const [orientations, setOrientations] = useState([]);
    const [showOverlay, setShowOverlay] = useState(false);
    useEffect(() => {
        fetData()
        fetchOrientations()
    }, [withOutRefresh])

    const fetchOrientations = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/orientation/index`, { headers: adminApiHeader });
            if (response.data?.status && response.data?.data) {
                setOrientations(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching orientations:', error);
        }
    };

    const fetData = async () => {
        try {
            setShowOverlay(true)
            const response = await axios.get(`${movieOrderDefaultURL?.editApi}/${id}`, { headers: adminApiHeader })
            const result = response?.data?.Web_Movies_HomePage_Order;
            if (response?.data?.status) {
                setApiData(result)
                setShowOverlay(false)
            }
            else {
                toast.error(response?.data?.message)
                setShowOverlay(false)
            }

        }
        catch (error) {
            const errMessage = error?.response?.data?.message
            console.error(errMessage)
        }
    }

    const handleInput = (e) => {
        const { name, value } = e.target;
        setApiData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    const handleOrientationChange = (e) => {
        const { name, value } = e.target;
        setApiData((prevFormData) => ({
            ...prevFormData,
            [name]: value || null
        }));
    };

    const [validationMessageheader_name, setValidationMessageheader_name] =
        useState("");
    const [isValidationHiddenheader_name, setIsValidationHiddenheader_name] =
        useState(true);

    const [validationMessageurl, setValidationMessageurl] =
        useState("");
    const [isValidationHiddenurl, setIsValidationHiddenurl] =
        useState(true);

    const header_nameInputRef = useRef(null);
    const url_nameInputRef = useRef(null);

    const handleUpdate = async (e) => {
        try {
            let focusInputRef = null;

            if (apiData?.header_name === "") {
                setValidationMessageheader_name("Header Name cannot be empty.");
                setIsValidationHiddenheader_name(false);
                focusInputRef = header_nameInputRef;
            }

            if (!apiData?.url || apiData.url.trim() === "") {
                setValidationMessageurl("Slug cannot be empty.");
                setIsValidationHiddenurl(false);
                focusInputRef = url_nameInputRef;
            }

            if (focusInputRef) {
                focusInputRef.current.focus();
                return;
            }

            e.preventDefault();

            setShowOverlay(true)
            const formData = new URLSearchParams();
            for (const key in apiData) {
                if (['id', 'header_name', 'url', 'web_orientation_view', 'mobile_orientation_view', 'tv_orientation_view'].includes(key)) {
                    const value = apiData[key] ?? "";
                    formData.append(key, value);
                }
            }
            const response = await axios.post(`${movieOrderDefaultURL?.updateApi}`, formData,

                {
                    headers: {
                        ...adminApiHeader,
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }
            )

            if (response?.data?.status) {
                setValidationMessageheader_name("");
                setValidationMessageurl("");
                toast.success(response?.data?.message)
                setShowOverlay(false)
                setWithOutRefresh(!withOutRefresh)
            }
            else {
                setIsValidationHiddenheader_name(false);
                setIsValidationHiddenurl(false);
                toast.error(response?.data?.message)
                setShowOverlay(false)
            }

        }
        catch (error) {
            const errMessage = error?.response?.data?.message
            console.error(errMessage)
        }
    }

    return (
        <div>
            {showOverlay && (<Response_Processing />)}
            {<AdminBackNavigation path={`${'/movie-settings'}`} text="Back" />}
            <AdminSaveHeader heading="Update Order Movie " saveText="Update Order" saveMethod={handleUpdate} />
            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        <MessageLabel text="Movie Header Name" className="mandatorySimple" />
                        <AdminCustomInput type="text" name="header_name" value={apiData?.header_name} maxLength={"50"} onChange={handleInput} placeHolder={"header name"} error={validationMessageheader_name} />
                        <MessageLabel text='Slug' className="mandatorySimple" />
                        <AdminCustomInput type="text" name="url" value={apiData?.url} onChange={handleInput} placeHolder={"Site url"} error={validationMessageurl} />
                    </Wrapper>
                </LeftWrapper>
                <RightWrapper>
                    <Wrapper>
                        <MessageHeading text={"Orientation Settings"} />
                        <MessageLabel text={"Web View Slider"} />
                        <AdminCustomSelect
                            name="web_orientation_view"
                            value={apiData?.web_orientation_view || ""}
                            onChange={handleOrientationChange}
                            options={orientations.map(orientation => ({
                                value: orientation.id,
                                name: `${orientation.name} (${orientation.images_size || 'N/A'})`
                            }))}
                            defaultOptionName="Select Orientation"
                        />
                        <MessageLabel text={"Mobile View Slider"} />
                        <AdminCustomSelect
                            name="mobile_orientation_view"
                            value={apiData?.mobile_orientation_view || ""}
                            onChange={handleOrientationChange}
                            options={orientations.map(orientation => ({
                                value: orientation.id,
                                name: `${orientation.name} (${orientation.images_size || 'N/A'})`
                            }))}
                            defaultOptionName="Select Orientation"
                        />
                        <MessageLabel text={"TV View Slider"} />
                        <AdminCustomSelect
                            name="tv_orientation_view"
                            value={apiData?.tv_orientation_view || ""}
                            onChange={handleOrientationChange}
                            options={orientations.map(orientation => ({
                                value: orientation.id,
                                name: `${orientation.name} (${orientation.images_size || 'N/A'})`
                            }))}
                            defaultOptionName="Select Orientation"
                        />
                    </Wrapper>
                </RightWrapper>
            </FormContainer>
        </div>
    )
}

export default MovieOrderEdit